import { Component, OnInit } from '@angular/core';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-cross-reference-feature',
  templateUrl: './cross-reference-feature.component.html',
  styleUrls: ['./cross-reference-feature.component.css']


})
export class CrossReferenceFeatureComponent implements OnInit {

  constructor(private sanitizer:DomSanitizer,public commonDataService: CommonDataService,
        private graphQlService: GraphqlService,  private openlink: OpenLinkById
  ) {

  }

  crf_header;
  crf_subtitle;
  crf_bystandardheader;
  crf_bystandardbody;
  crf_bycodificationheader;
  crf_bycodificationbody;

  ngOnInit(): void {
   
    this.commonDataService.showLoader.next(true);
    this.getCrossReferenceFeaturelabels();
  }
  getCrossReferenceFeaturelabels() {

    this.graphQlService.getcrossReferenceFeatureLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.crf_header = labels.filter(x => x.key == "crf_header").map(y => y.value);
        this.crf_subtitle = labels.filter(x => x.key == "crf_subtitle").map(y => y.value);
        this.crf_bystandardheader = labels.filter(x => x.key == "crf_bystandardheader").map(y => y.value);
        this.crf_bystandardbody = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "crf_bystandardbody").map(y => y.value));
        this.crf_bycodificationheader = labels.filter(x => x.key == "crf_bycodificationheader").map(y => y.value);
        this.crf_bycodificationbody = labels.filter(x => x.key == "crf_bycodificationbody").map(y => y.value);


        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });


  }
  openLinkById(event) {
    this.openlink.openLinkById(event);
  }
}


